import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';


class SpanDetails extends Component {

    randomNumberBetween = (minValue, maxValue) => this.roundDecimal((Math.random() * (maxValue - minValue) + minValue), 0);
    roundDecimal = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);


    render() {
        let length = this.randomNumberBetween(400, 760);
        let conductorsPerPhase = Math.random() < 0.75 ? '1' : '2';
        let earthPerTower = Math.random() < 0.6 ? '1' : '2';
        let wiresPerPhase = this.randomNumberBetween(20, 40);
        let wiresPerCore = this.randomNumberBetween(4, 10);

        return (
                <span>
                    <h3 style={{margin: '20px'}}><b>Span details</b></h3>
                    <Divider />
                <List>
                    <ListItem>
                        <ListItemText primary={'Name: ' + this.props.span.name} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Length: ' + length + ' m'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Conductor Type: ACSR'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Conductor Cross Section: 150'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Core Cross Section: 25'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Number of Conductors per Phase: ' + conductorsPerPhase} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Number of wires per Conductor: ' +  wiresPerPhase} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Number of wires per Core: ' + wiresPerCore} />
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={'Number of Earth Wire per Tower: ' + earthPerTower} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Rated Voltage: ' + this.props.span.voltage + ' kV'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Rated Current: /'} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={'Max. Short Circuit Current (1s): /'} />
                    </ListItem>
                </List>
                </span>
        )
    }
}


export default SpanDetails;

